import { useTheme } from '@mui/styles';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

const HighlightText = ({ text, search }) => {
    const theme = useTheme();
    const isMatch = useCallback((part) => {
        return (part || '').toLowerCase().includes((search || '').toLowerCase());
    }, [search]);

    const parts = (text || '').split(new RegExp(`(${search})`, 'gi'));

    return (search
        ? <span>
            {parts.map((part, i) => (
                <span key={i} style={isMatch(part) ? { fontWeight: 'bold', color: theme.palette.secondary.main } : {}}>
                    {part}
                </span>
            ))}
        </span> : text
    );
};

HighlightText.propTypes = {
    search: PropTypes.string,
    text: PropTypes.string,
};

export default HighlightText;
